import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { init } from '../editorconfig';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-staff-evaluation',
  standalone: false,
  templateUrl: './staff-evaluation.component.html',
  styleUrl: './staff-evaluation.component.scss'
})
export class StaffEvaluationComponent implements OnInit, OnDestroy, AfterViewInit {
  RFPForm: FormGroup;
  uploadedFiles: File[] = [];
  @Input() proposalName: any;
  @Input() proposalId: any;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
    @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  uploadedFileName: string = '';
  file: File;
  @Input() id: any;
  @Input() step: any;
  private subscriptions = new Subscription();
  userID: any;


  constructor(private fb: FormBuilder, private config: PrimeNGConfig, private messageService: MessageService, private api: ApiService, private route: ActivatedRoute) { 
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.RFPForm = this.fb.group({
      comment: ['', Validators.required],
    });
    this.getRfpDetails()
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if ( this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.RFPForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.RFPForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  goToNextStep() {
    this.stepCompleted.emit();
  }
  rfpdata: any;
  getRfpDetails() {
     const sub =   this.api.getAPI(`/make1/staff-evaluation/?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}`).subscribe((res: any) => {
          this.rfpdata = res[0];
          this.uploadedUrl = res[0].file || null;
          this.RFPForm.patchValue({
            comment: this.rfpdata?.justification
          });
        });
         this.subscriptions.add(sub);
  }



  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }

  onSubmit(): void {
    // if (this.commentForm.valid) {
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('justification', this.RFPForm.get('comment').value);
    if (this.file) {
      formData.append('file', this.file);
    }

    if (this.rfpdata) {
      const sub = this.api.putAPI(`/make1/staff-evaluation/${this.rfpdata.id}/`, formData).subscribe((res: any) => {
        this.getRfpDetails();
         this.uploadedUrl = null;
        this.uploadedFileName = ''
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data updated successfully' });
      });
      this.subscriptions.add(sub);

    } else {
      const sub = this.api.postAPI('/make1/staff-evaluation/', formData).subscribe((res: any) => {
        this.getRfpDetails();
         this.uploadedUrl = null;
        this.uploadedFileName = ''
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data uploaded successfully' });
      });
      this.subscriptions.add(sub);
    }
    // } else {
    //   this.commentForm.markAllAsTouched();
    // }
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.proposalName },
        { key: "Staff Evaluation", value: this.RFPForm.get('comment')?.value },
      ]
    }
    this.generatePDFEmitter.emit(payload);
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    this.uploadedUrl = null;
    fileUpload.clear();
  }
}
